/**
 * ============================================================
 * KEJJA OS — src/pages/community/CommunityMembersPage.tsx
 * Member list.
 * ============================================================
 */

import { Home as HomeIcon, Shield } from 'lucide-react';
import { useCommunityDetail } from './CommunityDetailLayout';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export default function CommunityMembersPage() {
  const { members, homeId } = useCommunityDetail();

  return (
    <div className="space-y-3">
      <p className="text-xs text-muted-foreground">
        Each member represents a home. Everyone in that home can see + post to this community.
      </p>
      <Card>
        <CardContent className="p-0 divide-y divide-border">
          {members.map((m) => {
            const isMe = m.home_id === homeId;
            return (
              <div key={m.home_id} className="p-3 flex items-start gap-3">
                <div className="h-8 w-8 rounded-lg bg-rose-100 dark:bg-rose-950/40 text-rose-700 dark:text-rose-300 flex items-center justify-center flex-shrink-0">
                  <HomeIcon className="w-4 h-4" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-semibold text-sm truncate">{m.home_name}</span>
                    {m.role === 'admin' && (
                      <Badge variant="outline" className="text-[9px] h-4 px-1 border-rose-300 text-rose-700 dark:text-rose-300">
                        <Shield className="w-2 h-2 mr-0.5" />admin
                      </Badge>
                    )}
                    {isMe && (
                      <Badge variant="outline" className="text-[9px] h-4 px-1 border-emerald-500/60 text-emerald-700 dark:text-emerald-300">
                        you
                      </Badge>
                    )}
                  </div>
                  {m.home_motto && (
                    <p className="text-[11px] text-muted-foreground italic mt-0.5 truncate">"{m.home_motto}"</p>
                  )}
                  {m.joined_at && (
                    <p className="text-[10px] text-muted-foreground mt-0.5">
                      Joined {new Date(m.joined_at).toLocaleDateString('en-KE', { month: 'short', year: 'numeric' })}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </CardContent>
      </Card>
    </div>
  );
}
